// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-collections-dropdown .dropdown .dropdown-menu{max-height:300px;overflow-y:auto;overflow-x:hidden;transition:all .5s ease 0s}@media(max-width:320px){.product-collections-dropdown .dropdown .dropdown-menu{max-height:200px}}@media(min-width:320px)and (max-width:576px){.product-collections-dropdown .dropdown .dropdown-menu{max-height:200px}}@media(min-width:576px)and (max-width:991px){.product-collections-dropdown .dropdown .dropdown-menu{max-height:300px}}", ""]);
// Exports
module.exports = exports;
